import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { constant } from '@app/utils/constant';

const PublicRoute = () => {
  let redirecturl = Cookies.get('ref');
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const isAuthenticated = isLoggedIn || Cookies.get(constant.Cookie_Name); 
  return isAuthenticated ? (redirecturl ? window.location.href = atob(redirecturl) : <Navigate to={'/'} />) : <Outlet />;
};

export default PublicRoute;
